export default "../css/74ff6b812423c87a99864d6562a7f5c0.ttf";